import * as React from 'react';
import cn from 'classnames';

import Close from '../icons/16/close';
import Text from '../text';

import { Chip as Props } from './chip.types';

const Chip: React.FC<Props> = ({
  elementName = 'button',
  className,
  icon = true,
  isSelected = false,
  text,
  ...rest
}) =>
  React.createElement(
    elementName,
    {
      className: cn('chip', className, { 'chip--selected': isSelected }),
      ...rest,
    },
    <React.Fragment>
      <div className="chip__wrapper">
        {icon ? <Close /> : null}
        <Text
          className="chip__text"
          size={Text.sizes.small}
          theme={Text.themes.emphasis}
        >
          {text}
        </Text>
      </div>
    </React.Fragment>,
  );

export default Chip;
